export { CourseInfo } from "./CourseInfo";
